import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LinkButton from './layout/LinkButton';
import { SimpleButton } from 'react-fast-ui';
import Overlay from './layout/Overlay';
import { SUPPORT_LINK } from '../constants/urls';

export default class FailedLoginScreen extends PureComponent {
  static propTypes = {
    errorMessage: PropTypes.string.isRequired,
    onLogin: PropTypes.func.isRequired,
  };

  render() {
    const { errorMessage, onLogin } = this.props;

    return (
      <Overlay
        className="justify-content-center"
        style={{ background: '#121212' }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            padding: 30,
          }}
          className="display-flex justify-content-space-between full-width"
        >
          <img
            src="https://id.fastmodelsports.com/assets/hudl/FastModelSportsHudl.png"
            width={300}
            alt="FastModel Logo"
          />
          {/* <img
            src="https://id.fastmodelsports.com/assets/hudl/FastScout.png"
            width={200}
            alt="Hudl Logo"
          /> */}
        </div>
        <div
          className="display-flex flex-direction-column align-items-center "
          style={{
            background: '#191f25',
            width: 400,
            padding: 30,
            textAlign: 'left',
            borderRadius: 10,
            color: '#c3cedb',
            fontFamily: 'helvetica',
          }}
        >
          <div
            className="helvetica"
            style={{
              fontSize: 30,
              color: '#c3cedb',
              textAlign: 'center',
              marginBottom: '1em',
            }}
          >
            Admin Role Required
          </div>

          <p className="mg-top-md mg-bottom-none">
            Need access to the Admin Portal? Contact your account admin or Hudl
            support.
          </p>
          <div className="display-flex justify-content-center align-items-center mg-top-xl">
            <a
              style={{
                border: '1px solid black',
                padding: '15px 100px',
                fontWeight: 'normal',
                backgroundColor: '#027dbb',
                color: '#FFF',
                textDecoration: 'none',
              }}
              href={SUPPORT_LINK}
            >
              Contact Support
            </a>
          </div>
          <div
            onClick={onLogin}
            style={{
              marginTop: '2em',
              cursor: 'pointer',
              color: '#c3cedb',
              textAlign: 'center',
            }}
          >
            Back to Hudl
          </div>
        </div>
      </Overlay>
    );
  }
}
